module.exports = __webpack_public_path__ + "img/rx-dm0max-white.f07b0410.png";